"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.richTextEditor = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var dictionary_1 = require("Views/Partials/Pages/ContactUsContentPage/dictionary");
var ContactFormService_1 = require("Views/Partials/Pages/ContactUsContentPage/ContactFormService");
var client_1 = require("react-dom/client");
var React = require("react");
var ContactForm_1 = require("Views/Partials/Pages/ContactUsContentPage/ContactForm");
var RichTextEditor = /** @class */ (function (_super) {
    tslib_1.__extends(RichTextEditor, _super);
    function RichTextEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.rte-default';
        _this.removeContactForm = function () {
            _this.root.unmount();
        };
        return _this;
    }
    RichTextEditor.prototype.OnInit = function () {
        this.root = (0, client_1.createRoot)(this.contactFormContainer);
        this.el.forEach(function (el) {
            var rteElem = el;
            var links = rteElem.querySelectorAll('a');
            var externalLink = new app_1.ExternalLink(links);
            Array.from(links).forEach(function (l) { return l.setAttribute('style', 'display:inline-block'); });
            externalLink.checkLinks();
        });
        this.setContactUsForm();
    };
    RichTextEditor.prototype.setContactUsForm = function () {
        try {
            if (document.body.dataset.contactUsForm) {
                var contactUsFormData = JSON.parse(document.body.dataset.contactUsForm);
                var container = document.createElement('div');
                container.id = 'contact-us-form-container';
                this.contactFormContainer = document.body.appendChild(container);
                var dictionary = (0, app_1.transformDictionary)(dictionary_1.contactUsContentPageDictionary, JSON.parse(contactUsFormData.dictionary));
                var culture = contactUsFormData.culture;
                var locationApiUrl = contactUsFormData.locationApiBaseUrl;
                var locationApiKey = contactUsFormData.locationApiKey;
                var formsServiceApiUrl = contactUsFormData.formServiceApiUrl;
                var contactsApiUrl = this.getContactsApiUrl(locationApiUrl);
                this.contactFormContainer = document.getElementById('contact-us-form-container');
                this.processContactUsFormLinks(culture, dictionary, locationApiUrl, formsServiceApiUrl, contactsApiUrl, locationApiKey);
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    RichTextEditor.prototype.getContactsApiUrl = function (locationUrl) {
        var danfossLocationsApiPath = '/danfoss-location/danfosslocations';
        return "".concat(locationUrl).concat(danfossLocationsApiPath);
    };
    RichTextEditor.prototype.processContactUsFormLinks = function (culture, dictionary, locationApiUrl, formsServiceApiUrl, contactsApiUrl, locationApiKey) {
        var _this = this;
        var contactUsFormLinks = document.querySelectorAll('button[data-type=contactUsForm]');
        var contactUsFormLinksCount = contactUsFormLinks.length;
        var contactFormService = new ContactFormService_1.ContactFormService(contactsApiUrl, locationApiKey);
        var _loop_1 = function (i) {
            var link = contactUsFormLinks[i];
            var contactId = link.dataset.contactId;
            link.setAttribute('aria-haspopup', 'dialog');
            link.addEventListener('click', function () {
                _this.root.render(React.createElement(ContactForm_1.ContactForm, { contactId: contactId, culture: culture, dictionary: dictionary, locationApiUrl: locationApiUrl, formsServiceApiUrl: formsServiceApiUrl, contactFormService: contactFormService, onFormClose: _this.removeContactForm }), _this.contactFormContainer);
            });
        };
        for (var i = 0; i < contactUsFormLinksCount; i++) {
            _loop_1(i);
        }
    };
    return RichTextEditor;
}(app_1.Component));
exports.richTextEditor = new RichTextEditor();
